import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ContentMessage } from '@interfaces/content-message.model';
import { ContentMessagingService } from '@services/content-messaging/content-messaging.service';
import { TrackByUtilities } from '@utilities/trackByFn.utilities';
import { Observable, Subscription } from 'rxjs';

@Component({
  selector: 'app-content-messaging',
  templateUrl: './content-messaging.component.html',
  styleUrls: ['./content-messaging.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ContentMessagingComponent implements OnInit, OnDestroy {
  public homepageMessages: Observable<ContentMessage[]>;
  public activeItemIndex: number;
  public trackById: any = TrackByUtilities.trackByFnItemId;
  private routeParamsSubscription: Subscription;

  constructor(
    private contentMessagingService: ContentMessagingService,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.routeParamsSubscription = this.subscribeToRouteParams();
  }

  ngOnDestroy() {
    this.routeParamsSubscription.unsubscribe();
  }

  private subscribeToRouteParams(): Subscription {
    return this.route.queryParams.subscribe(
      () =>
        (this.homepageMessages =
          this.contentMessagingService.getHomepageMessages())
    );
  }
}
